import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GoodsShipmentItemIDocuments } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface SaveGoodsItemDocumentsProps {
  declarationId: string;
  goodsItemId: string;
  documents: GoodsShipmentItemIDocuments;
}

const saveGoodsItemDocuments = async ({ declarationId, goodsItemId, documents }: SaveGoodsItemDocumentsProps) => {
  const { data } = await request({
    path: `declarations/${declarationId}/save-goods-item-documents/${goodsItemId}`,
    method: 'POST',
    authenticate: true,
    dataObject: { documents },
  });
  return data;
};

export const useSaveGoodsItemDocuments = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveGoodsItemDocuments,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declarationId] });
    },
    onError: (error) => {
      showErrorToast(error, 'Error saving goods item documents!');
    },
  });
};
